import { Page } from '@/core/architecture'

import { ConsoleCollectionCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleCollectionCreate Page
 * Implemented as a practical sample.
 */
export const ConsoleCollectionCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleCollectionCreateTemplate state={state} {...actions} />
}
